import { formatPercent } from '@angular/common';
import pptxgen from 'pptxgenjs';
import { AbinResultDto } from 'src/app/inge-api/abinclient/models';
import { _andelBarchartOptions } from '../slide-components/_andelBarchart';
import addBanner from '../slide-components/_banner';
import { sammanvagningCardOptions } from '../slide-components/_sammanvagningCard';
import { getComboChartOptions, getComboTypes } from '../pptx-chart-utils';
import { getYAxisMaxValueFromList } from '../../../google-charts/google-chart-utils';

export default (slide: pptxgen.Slide, inventeringar: AbinResultDto[], chartImg: string) => {
    addBanner(slide, {
        header: 'Årsskador gran',
        text: 'Om viltskador på gran är högt kan det bero på en obalans mellan hjortdjur och fodertillgång. Var gränsen för obalans exakt går är dock oklart. En indikation om att obalans råder i området inträder när andelen gran med årligt uppkomna viltskador överskrider 1 %.'
    });

    //
    const senasteInventering = inventeringar[0];
    const comboTypes = getComboTypes(inventeringar, 'arsskadaGranAndel', 'arsskadaGranAndel3InvMedel');
    const maxValue = getYAxisMaxValueFromList([...comboTypes[0].data[0].values, ...comboTypes[1].data[0].values]);
    let comboOptions = getComboChartOptions('Andel av granstammarna i ungskog som årligen skadas av vilt', maxValue);
    comboOptions = { ...comboOptions, dataLabelFormatCode: '0.0' };
    slide
        .addImage({
            data: chartImg,
            x: 0.5,
            y: 1.5,
            w: 9,
            h: 4.5
        })
        .addText('Felmarginal visas med felstaplar samt en ljusblå zon. Definition för felmarginal finns längst ner i rapporten.', {
            w: 8,
            h: 0.5,
            x: 1,
            y: 6.2,
            fontSize: 8,
            bold: false,
            align: 'center',
            valign: 'top'
        })
        .addShape('rect', sammanvagningCardOptions())
        .addImage({
            path:
                senasteInventering.slutsatsArsskadaGranInt > 0
                    ? 'assets/abin-icons-png/Arsskada_gran_uppfyllt-2022.svg'
                    : 'assets/abin-icons-png/Arsskada_gran_ej_uppfyllt-2022.svg',
            sizing: { type: 'cover', w: 1.13, h: 1.12 },
            x: 10.69,
            y: 2.39
        })
        .addText(formatPercent(senasteInventering.arsskadaGranAndel3InvMedel, 'sv-se', '1.1-1'), {
            h: 0.91,
            w: 2.83,
            x: 9.77,
            y: 3.47,
            fontSize: 48,
            bold: true,
            align: 'center'
        })
        .addText('Andel årsskador på gran, sammanvägning för de tre senaste inventeringarna', {
            w: 2.83,
            x: 9.77,
            h: 0.81,
            y: 4.38,
            fontSize: 14,
            bold: false,
            align: 'center',
            valign: 'top'
        });
};
